
import React, { useState } from "react";
import EmailInput from "../../Features/Forms/Components/Inputs/EmailInput";
import PasswordInput from "../../Features/Forms/Components/Inputs/PasswordInput";
import Checkbox from "../../Features/Forms/Components/Inputs/CheckBoxInput";
import Btn from "../../Components/Buttons/Btn";
import useAxios from "../../Hooks/useAxios";
import useForm from "../../Features/Forms/Components/hooks/useForm";
import useApp from "../../Hooks/useApp";
import initial_user from "./initial_user";
import { useNavigate, Link } from "react-router-dom";
import backgroundImage from "../../Assets/images/bg.png";
import { storeEncryptedData } from "../../Util/store";


const LoginForm = () => {
  const navigate = useNavigate();
  const [input, setInput] = useState(initial_user);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const { setUser, setToken } = useApp();
  const request = useAxios();

  const handleSubmit = async (data) => {
    let res = await request({
      method: "POST",
      url: "members/login",
      body: {
        email: data?.email,
        password: data?.password,
      },
      show_loading: true,
      show_error: true,
    });

    if (res !== "error") {
      setUser(res.user);
      storeEncryptedData('token', res.token); 
      setToken(res.token);
      storeEncryptedData('user', res.user);
      navigate("/dashboard");
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotPasswordEmail) {
      alert("Please enter your email address");
      return;
    }

    const res = await request({
      method: "PUT",
      url: "members/update-password1",
      body: { email: forgotPasswordEmail },
      show_loading: true,
      show_error: true,
    });

    if (res !== "error") {
      alert("Password reset instructions have been sent to your email");
      setShowForgotPasswordModal(false);
      setForgotPasswordEmail("");
    }
  };

  const { handleValidation, validate } = useForm({
    submit: handleSubmit,
    input: input,
  });

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="w-full max-w-xl bg-neutral-white bg-opacity-80 p-12 rounded-lg shadow-lg border border-light_grey">
        <div className="flex justify-center mb-8">
          <h3 className="text-4xl font-bold text-primary">Welcome Back!</h3>
        </div>
        <form className="space-y-6">
          <div>
            <EmailInput
              input={input}
              setInput={setInput}
              field="email"
              validate={validate}
              className=""
            />
          </div>
          <div>
            <PasswordInput
              input={input}
              setInput={setInput}
              field="password"
              validate={validate}
              className=""
            />
          </div>
          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center gap-2">
              <Checkbox input={input} setInput={setInput} field="checkbox" />
            </div>
            <button
              type="button"
              className="text-primary hover:underline font-semibold"
              onClick={() => setShowForgotPasswordModal(true)}
            >
              Forgot password?
            </button>
          </div>
          <Btn
            onClick={handleValidation}
            size="block"
            rounded={true}
          >
            Log In
          </Btn>
        </form>
      </div>

      {/* Forgot Password Modal */}
      {showForgotPasswordModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-xl">
      <h3 className="text-xl font-bold mb-4 text-primary">enter Reset password</h3>
      <input
        type="email"
        value={forgotPasswordEmail}
        onChange={(e) => setForgotPasswordEmail(e.target.value)}
        placeholder="Enter your email"
        className="w-full border border-gray-300 rounded p-2 mb-4"
      />
      <div className="flex justify-end space-x-2">
        <button
          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          onClick={() => setShowForgotPasswordModal(false)}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
          onClick={handleForgotPassword}
        >
          Submit
        </button>
      </div>
    </div>
  </div>
)}

  </div>
  );
};

export default LoginForm;